module.exports = __webpack_public_path__ + "static/img/26.9af7a1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/26.jpg
// module id = GZ8D
// module chunks = 0